import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { IconCheck } from "@tabler/icons-react";
import { cva } from "class-variance-authority";
import type { VariantProps } from "class-variance-authority";
import clsx from "clsx";
import * as React from "react";

const checkboxStyles = cva(
	"relative inline-flex justify-center items-center shrink-0 rounded-sm bg-background border border-border focus:border-focus-border focus:ring-2 ring-offset-0 focus:ring-focus-ring/30 outline-0 overflow-hidden",
	{
		variants: {
			size: {
				sm: "min-h-[12px] h-[12px] max-h-[12px] min-w-[12px] w-[12px] max-w-[12px]",
				md: "min-h-[16px] h-[16px] max-h-[16px] min-w-[16px] w-[16px] max-w-[16px]",
				lg: "min-h-[20px] h-[20px] max-h-[20px] min-w-[20px] w-[20px] max-w-[20px]",
			},
			color: {
				default: "data-[state=checked]:bg-primary-600 data-[state=checked]:border-primary-600",
				red: "data-[state=checked]:bg-red-600 data-[state=checked]:border-red-600",
				blue: "data-[state=checked]:bg-blue-600 data-[state=checked]:border-blue-600",
				green: "data-[state=checked]:bg-green-600 data-[state=checked]:border-green-600",
				yellow: "data-[state=checked]:bg-yellow-600 data-[state=checked]:border-yellow-600",
			},
			borderWidth: {
				sm: "border-[1px]",
				md: "border-[2px]",
				lg: "border-[2px]",
			},
		},
		defaultVariants: {
			size: "md",
			color: "default",
			borderWidth: "md",
		},
	},
);

const Checkbox = React.forwardRef<
	React.ElementRef<typeof CheckboxPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root> &
		VariantProps<typeof checkboxStyles> & {
			strokeWidth?: number;
			borderWidth?: "sm" | "md" | "lg";
		}
>(({ className, size, color, strokeWidth = 3, borderWidth = "md", ...props }, ref) => (
	<div className="relative inline-flex">
		<CheckboxPrimitive.Root ref={ref} className={clsx(checkboxStyles({ size, color, borderWidth }), className)} {...props}>
			<CheckboxPrimitive.Indicator className="absolute inset-0 flex items-center justify-center w-full h-full text-white">
				<IconCheck size={size === "sm" ? 8 : size === "lg" ? 12 : 10} stroke={strokeWidth} />
			</CheckboxPrimitive.Indicator>
		</CheckboxPrimitive.Root>
	</div>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
